/**
 * plugins/index.ts
 *
 * Automatically included in `./src/main.ts`
 */

// Plugins
import { icons } from '@gat-ship/icons'
import { routeDefinitions } from '@gat-ship/lib/router'
import { accessCodes } from '@gat-ship/types'
import { createPinia } from 'pinia'
import '../styles/main.css' // Global tailwind theme.
import { type App } from 'vue'
import router from '../router/app-router'
import auth0 from './auth-0/app-plugin-auth0'

export function registerPlugins(app: App) {
  app.use(auth0).use(createPinia()).use(router)
}

export function registerGlobalProperties(app: App) {
  app.config.globalProperties.icons = icons
  app.config.globalProperties.routeDefinitions = routeDefinitions
  app.config.globalProperties.$routeDefinitions = routeDefinitions
  app.config.globalProperties.accessCodes = accessCodes
}
